import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Download immediato',
  desc: 'Acquista e accedi subito ai 6 volumi e ai 5 bonus. Inizia quando vuoi, senza attese.'
}, {
  n: '2',
  title: 'Valuta e progredisci fase dopo fase',
  desc: 'Esegui la valutazione, gestisci la fase acuta e applica il rinforzo progressivo con i criteri di ogni fase. Il sistema è la tua mappa.'
}, {
  n: '3',
  title: 'Ritorno allo sport in sicurezza',
  desc: 'Supera i checkpoint di "Return to Sport" e monitora i progressi con il Diario di Allenamento per evitare recidive.'
}];
export function Steps() {
  return <section aria-label="Come funziona" className="bg-transparent" data-id="element-169" data-mp="bq6woikoftt6">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-170" data-mp="fpxrqyh8kw3i">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-171" data-mp="262mwp1mvqbpl">
          Come inizierai a progredire da oggi
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-172" data-mp="1qau0k4gm6wlf">In 3 semplici passi</p>

        <ol className="mt-10 space-y-4" data-id="element-173" data-mp="1lcis9y5ywu5b">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-174" data-mp="1lbzcamzvoftx" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-175" data-mp="12eg7jvkgdjdb">
                {s.n}
              </span>
              <div data-id="element-176" data-mp="1cajah3n4pm1b">
                <h3 className="text-base font-bold text-plum" data-id="element-177" data-mp="1c9ztpq97t3ov">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-178" data-mp="2sormi4a9wcyp">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}